import { Button, ErrorState, Skeleton } from '@convometry/ui';
import { Navigate, Outlet, useLocation } from 'react-router';
import { ApiError } from '../lib/api.js';
import { useMe } from './session.js';

/** Gate for authenticated routes. The server still authorizes every request. */
export function RequireSession() {
  const me = useMe();
  const location = useLocation();
  if (me.isPending) {
    return (
      <div className="grid min-h-dvh place-items-center bg-surface-canvas">
        <Skeleton className="h-8 w-40" label="Cargando sesión" />
      </div>
    );
  }
  if (me.isError) {
    if (me.error instanceof ApiError && me.error.kind === 'unauthorized') {
      const next = location.pathname === '/' ? '' : `?siguiente=${encodeURIComponent(location.pathname + location.search)}`;
      return <Navigate to={`/iniciar-sesion${next}`} replace />;
    }
    return (
      <div className="grid min-h-dvh place-items-center bg-surface-canvas p-4">
        <ErrorState description={me.error.message} action={<Button onClick={() => void me.refetch()}>Reintentar</Button>} />
      </div>
    );
  }
  return <Outlet />;
}
